namespace Seac.Services {
	/** Identificativo e valore del filtro */
	interface FilterIdentifierData {
		gridInternalId		: string,
		filtersIdentifier	: string,
		filters				: GridFilters
	}

	class GridFilterPersistenceService {
		public gridFiltersSuffix : string = 'gridFilters_';
		/** Nome dell'attributo in cui è salvato il valore originale */
		private _originalValueDataAttributeName: string = 'persistence-original-value';
		/** Chiave egenerica nel caso in cui non sia selezionata un'impresa */
		private _genericImpresa: string = 'generic';
		/** Chiave egenerica nel caso in cui non sia selezionata un ufficio */
		private _genericUfficio: string = 'generic';

		/**
		 * Legge i valori degli elementi marcati con la classe `filter-control` o `seac-dx-page-selector-select` nel localStorage
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @returns Filtri letti per la pagina
		 */
		public readFilterControlsValue(gridId: string): Array<GridFiltersValue> {
			const gridFiltersValueList: Array<GridFiltersValue> = [];

			$(`.filter-control, .seac-dx-page-selector-select`).each((index: number, element: HTMLElement) => {
				if (!element.id && !$(element).hasClass('seac-dx-page-selector-select')) {
					console.error(`Nessun Id impostato per l\'input del filtro da salvare ${$(element).attr(Seac.Commons.Constants.elementName)}`);
					return;
				}
				// Se l'elemento non ha un id, do per scontato che sia un PageSelctor
				const elementIdentifier: string = !$(element).hasClass('seac-dx-page-selector-select') ? element.id : 'seac-dx-page-selector-select';
				let value: any;
				// Ricavo il valore dell'elemento in base al tipo del controllo
				if (element.tagName === Seac.Commons.Constants.inputElement.toUpperCase() || element.tagName ===  Seac.Commons.Constants.selectElement.toUpperCase()) {
					if ($(element).attr('type') === 'checkbox') {
						value = $(element).is(`:${Seac.Commons.Constants.checked}`);
					}else {
						value = $(element).val();
					}
				}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-selectbox')) {
					const selectBoxInstance: DevExpress.ui.dxSelectBox = $(element).dxSelectBox(Seac.Commons.Constants.DevExpress.dxInstance);
					value = selectBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
				}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-dropdownbox')) {
					const dropdownBoxInstance: DevExpress.ui.dxDropDownBox = $(element).dxDropDownBox(Seac.Commons.Constants.DevExpress.dxInstance);
					value = dropdownBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
				}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-datebox')) {
					const dateBoxInstance: DevExpress.ui.dxDateBox = $(element).dxDateBox(Seac.Commons.Constants.DevExpress.dxInstance);
					value = dateBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
				}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-switch')) {
					const switchInstance: DevExpress.ui.dxSwitch = $(element).dxSwitch(Seac.Commons.Constants.DevExpress.dxInstance);
					value = switchInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
				}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-numberbox')) {
					const numberBoxInstance: DevExpress.ui.dxNumberBox = $(element).dxNumberBox(Seac.Commons.Constants.DevExpress.dxInstance);
					value = numberBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
				}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-textbox')) {
					const textBoxInstance: DevExpress.ui.dxTextBox = $(element).dxTextBox(Seac.Commons.Constants.DevExpress.dxInstance);
					value = textBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
				}

			//	// Elimino (se presente) il valore corrente dai filtri salvati
			//	let currentControlIndex: number = this.findFilterIndex(gridFilters, internalGridId, elementIdentifier);
			//	if (currentControlIndex > -1) {
			//		gridFilters[internalGridId].splice(currentControlIndex, 1);
			//	}

				// Se è stato settato un valore lo salvo
				if ((value !== null) && (value !== undefined)) {
					gridFiltersValueList.push(<GridFiltersValue> { [elementIdentifier] : value });
				}
			});

			return gridFiltersValueList;
		}

		/** Identificativo del filtro per 'gridId' e valore dei filtri dell'impresa */
		private filterIdentifierData(gridId: string, ignoreImpresa: boolean, isPerPagina: boolean): FilterIdentifierData {
			let selectedImpresa: string = this._genericImpresa;
			let selectedUfficio: string = this._genericUfficio;
			// Se l'impresa fa riferimento, leggo i suoi valori
			if (!ignoreImpresa) {
				const cookieImpresa: string = Cookies.get(Seac.Commons.ServerConstants.Constants.COOKIE_IMPRESA_ID);
				if (cookieImpresa) {
					selectedImpresa = cookieImpresa;
				}

				const cookieUfficio: string = Cookies.get(Seac.Commons.ServerConstants.Constants.COOKIE_UFFICIO_BASE_ID);
				if (cookieUfficio) {
					selectedUfficio = cookieUfficio;
				}
			}

			const gridFiltersIdentifier: string = `${this.gridFiltersSuffix}${selectedImpresa}_${selectedUfficio}`;
			// Recupero il valore dei filtri dal localStorage
			const gridFilters: GridFilters = JSON.parse(localStorage.getItem(gridFiltersIdentifier)) || <GridFilters>{};
			// Metto la prima parte dell'url nell'identificativo, in modo da prevenire il fatto che ci possano essere due griglie con lo stesso nome
			const internalGridId: string = isPerPagina
				? `${window.location.pathname.replace(/\//g, '')}_${gridId}`
				: gridId
			;

			return <FilterIdentifierData>{
				gridInternalId		: internalGridId,
				filtersIdentifier	: gridFiltersIdentifier,
				filters				: gridFilters
			};
		}

		/**
		 * Salva i valori degli elementi marcati con la classe `filter-control` o `seac-dx-page-selector-select` nel localStorage
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param ignoreImpresa Indica se salvare il filtro come generico, anziché assegnato all'impresa corrente
		 * @returns Filtri salvati per la pagina
		 */
		public saveFilterControlsValue(gridId: string, ignoreImpresa: boolean): Array<GridFiltersValue> {
			const filterIdentifier = this.filterIdentifierData(gridId, ignoreImpresa, /*isPerPagina*/true);
			// Leggo i valori del filtro in pagina
			const gridFiltersValueList: Array<GridFiltersValue> = this.readFilterControlsValue(gridId);
			filterIdentifier.filters[filterIdentifier.gridInternalId] = gridFiltersValueList;

			// Salvo i filtri nel localStorage
			localStorage.setItem(filterIdentifier.filtersIdentifier, JSON.stringify(filterIdentifier.filters));

			return gridFiltersValueList;
		}

		/**
		 * Salva i valori extra del filtro per `gridId` nel localStorage
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param ignoreImpresa Indica se salvare il filtro come generico, anziché assegnato all'impresa corrente
		 * @returns Filtri salvati per la pagina
		 */
		public saveFilterExtraValue(gridId: string, ignoreImpresa: boolean, isPerPagina: boolean, ...extraFilterList: Array<GridFiltersValue>): Array<GridFiltersValue> {
			const filterIdentifier = this.filterIdentifierData(`${gridId}_extra`, ignoreImpresa, isPerPagina);
			let gridFiltersValueList: Array<GridFiltersValue> | null = filterIdentifier.filters[filterIdentifier.gridInternalId] || (filterIdentifier.filters[filterIdentifier.gridInternalId] = []);

			// Leggo le chiavi dei filtri da aggiungere e li rimuovo dai valori precedenti
			const extraKeyList = extraFilterList.map((gridFiltersValue: GridFiltersValue) => Object.keys(gridFiltersValue)[0]);
			gridFiltersValueList = gridFiltersValueList.filter((gridFiltersValue: GridFiltersValue) => extraKeyList.indexOf(Object.keys(gridFiltersValue)[0]) < 0);
			filterIdentifier.filters[filterIdentifier.gridInternalId] = gridFiltersValueList;

			// Aggiungo i filtri richiesti
			gridFiltersValueList.push(...extraFilterList);

			// Salvo i filtri nel localStorage
			localStorage.setItem(filterIdentifier.filtersIdentifier, JSON.stringify(filterIdentifier.filters));

			return gridFiltersValueList;
		}

		/**
		 * Legge i valori extra del filtro per `gridId` nel localStorage
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param ignoreImpresa Indica se salvare il filtro come generico, anziché assegnato all'impresa corrente
		 * @returns Filtri salvati per la pagina corrisposti in un array di valori in cui le chiavi sono i nomi dei filtri
		 */
		public readFilterExtraValue(gridId: string, ignoreImpresa: boolean, isPerPagina: boolean): Array<any> {
			const filterIdentifier = this.filterIdentifierData(`${gridId}_extra`, ignoreImpresa, isPerPagina);
			const gridFiltersValueList: Array<GridFiltersValue> | null = filterIdentifier.filters[filterIdentifier.gridInternalId] || (filterIdentifier.filters[filterIdentifier.gridInternalId] = []);

			return gridFiltersValueList.reduce<Array<any>>((prevValue, currentValue) => {
				prevValue[Object.keys(currentValue)[0]] = Object.values(currentValue)[0];

				return prevValue;
			}, []);
		}

		/**
		 * Salva i valori extra del filtro per `gridId` nel localStorage
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param ignoreImpresa Indica se salvare il filtro come generico, anziché assegnato all'impresa corrente
		 * @returns Filtri salvati per la pagina
		 */
		public deleteFilterExtraValue(gridId: string, ignoreImpresa: boolean, isPerPagina: boolean, ...extraFilterKeyList: Array<string>): Array<GridFiltersValue> {
			const filterIdentifier = this.filterIdentifierData(`${gridId}_extra`, ignoreImpresa, isPerPagina);
			let gridFiltersValueList: Array<GridFiltersValue> | null = filterIdentifier.filters[filterIdentifier.gridInternalId] || (filterIdentifier.filters[filterIdentifier.gridInternalId] = []);

			// Rimuovo le chivi richieste
			filterIdentifier.filters[filterIdentifier.gridInternalId] = gridFiltersValueList.filter((gridFiltersValue: GridFiltersValue) => extraFilterKeyList.indexOf(Object.keys(gridFiltersValue)[0]) < 0);

			// Salvo i filtri nel localStorage
			localStorage.setItem(filterIdentifier.filtersIdentifier, JSON.stringify(filterIdentifier.filters));

			return gridFiltersValueList;
		}

		/**
		 * Recupera i valori degli elementi marcati con la classe `filter-control` o `seac-dx-page-selector-select` dal localStorage
		 * @param gridId ID univoco della griglia a cui appartengono i filtri* @param gridId
		 * @param normalize Funzione facoltativa di normalizzazione del dato letto. Viene utilizzata per modificare il valore del filtro letto, per esempio per convertire le date da stringa a Data oppure per recuperare l'effettivo item da una selectbox.
		 * @param ignoreImpresa Indica se leggere il filtro come generico, anziché assegnato all'impresa corrente
		 * @returns Filtri presenti
		 */
		public restoreFilterControlsValue(gridId: string, normalize: GridFiltersValueNormalize = null, ignoreImpresa: boolean = false): Array<GridFiltersValue> | null {
			const filterIdentifier = this.filterIdentifierData(gridId, ignoreImpresa, /*isPerPagina*/true);

			if (filterIdentifier.filters[filterIdentifier.gridInternalId]) {
				// Controllo se normalizzare i valori dei filtri
				if (normalize) {
					for (let filterIndex = 0; filterIndex < filterIdentifier.filters[filterIdentifier.gridInternalId].length; filterIndex++) {
						for (let filterName in filterIdentifier.filters[filterIdentifier.gridInternalId][filterIndex]) {
							filterIdentifier.filters[filterIdentifier.gridInternalId][filterIndex][filterName] = normalize(
								filterName,
								filterIdentifier.filters[filterIdentifier.gridInternalId][filterIndex][filterName]
							);
						}
					}
				}

				$(`.filter-control, .seac-dx-page-selector-select`).each((index: number, element: HTMLElement) => {
					const jElement: JQuery = $(element);
					// Se l'elemento non ha un id, do per scontato che sia un PageSelctor
					const elementIdentifier: string = !jElement.hasClass('seac-dx-page-selector-select') ? element.id : 'seac-dx-page-selector-select';
					// Recupero l'indice dell'elemento corrente
					const currentControlIndex: number = this.findFilterIndex(filterIdentifier.filters, filterIdentifier.gridInternalId, elementIdentifier);
					if (currentControlIndex > -1) {
						const value: any = filterIdentifier.filters[filterIdentifier.gridInternalId][currentControlIndex][elementIdentifier];
						// Se è presente un valore lo setto nel controllo
						if ((value === null) || (value === undefined)) {
							return ;
						}

						if (element.tagName === Seac.Commons.Constants.inputElement.toUpperCase() || element.tagName ===  Seac.Commons.Constants.selectElement.toUpperCase()) {
							if (jElement.attr('type') === 'checkbox') {
								jElement.prop(Seac.Commons.Constants.checked, value);
							}else {
								if (elementIdentifier === 'seac-dx-page-selector-select') {
									$(`#${gridId}`).dxDataGrid(Seac.Commons.Constants.DevExpress.dxInstance).pageSize(+value);
								}
								jElement.val(value);
							}
						}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-selectbox')) {
							const selectBoxInstance: DevExpress.ui.dxDropDownBox = jElement.dxSelectBox(Seac.Commons.Constants.DevExpress.dxInstance);
							selectBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
						}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-dropdownbox')) {
							const dropdownBoxInstance: DevExpress.ui.dxDropDownBox = jElement.dxDropDownBox(Seac.Commons.Constants.DevExpress.dxInstance);
							dropdownBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
						}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-datebox')) {
							const dateBoxInstance: DevExpress.ui.dxDateBox = jElement.dxDateBox(Seac.Commons.Constants.DevExpress.dxInstance);
							const dateValue: Date = new Date(value);
							dateBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, dateValue);
						}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-switch')) {
							const switchInstance: DevExpress.ui.dxSwitch = jElement.dxSwitch(Seac.Commons.Constants.DevExpress.dxInstance);
							switchInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
						}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-numberbox')) {
							const numberBoxInstance: DevExpress.ui.dxNumberBox = jElement.dxNumberBox(Seac.Commons.Constants.DevExpress.dxInstance);
							numberBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
						}else if ($(element).hasClass('dx-widget') && $(element).hasClass('dx-textbox')) {
							const textBoxInstance: DevExpress.ui.dxTextBox = $(element).dxTextBox(Seac.Commons.Constants.DevExpress.dxInstance);
							textBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
						}

						// Salvo il valore originale negli attributi dell'elemento
						jElement.data(this._originalValueDataAttributeName, value);
					}
				});
			}

			return filterIdentifier.filters[filterIdentifier.gridInternalId];
		}

		/**
		 *  Ripristina il valore di un singolo elemento del filtro
		 *  @returns Il valore impostato, null altrimenti
		 */
		public restoreFilterControlsOriginalValue(element: HTMLElement | JQuery<HTMLElement>): any | null {
			const jElement	: JQuery	= $(element);
			const value		: any		= this.getOriginalValue(jElement);
			// Se è presente un valore lo setto nel controllo
			if ((value === null) || (value === undefined)) {
				return null;
			}

			if (jElement[0].tagName === Seac.Commons.Constants.inputElement.toUpperCase() || jElement[0].tagName ===  Seac.Commons.Constants.selectElement.toUpperCase()) {
				if (jElement.attr('type') === 'checkbox') {
					jElement.prop(Seac.Commons.Constants.checked, value);
				}
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-selectbox')) {
				const selectBoxInstance: DevExpress.ui.dxDropDownBox = jElement.dxSelectBox(Seac.Commons.Constants.DevExpress.dxInstance);
				selectBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-dropdownbox')) {
				const dropdownBoxInstance: DevExpress.ui.dxDropDownBox = jElement.dxDropDownBox(Seac.Commons.Constants.DevExpress.dxInstance);
				dropdownBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-datebox')) {
				const dateBoxInstance: DevExpress.ui.dxDateBox = jElement.dxDateBox(Seac.Commons.Constants.DevExpress.dxInstance);
				const dateValue: Date = new Date(value);
				dateBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, dateValue);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-switch')) {
				const switchInstance: DevExpress.ui.dxSwitch = jElement.dxSwitch(Seac.Commons.Constants.DevExpress.dxInstance);
				switchInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-numberbox')) {
				const numberBoxInstance: DevExpress.ui.dxNumberBox = jElement.dxNumberBox(Seac.Commons.Constants.DevExpress.dxInstance);
				numberBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-textbox')) {
				const textBoxInstance: DevExpress.ui.dxTextBox = jElement.dxTextBox(Seac.Commons.Constants.DevExpress.dxInstance);
				textBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, value);
			}

			return value;
		}

		/** Controlla se l'elemento ha il valore originale */
		public hasFilterOriginalValue(element: HTMLElement | JQuery<HTMLElement>): boolean {
			const	jElement	: JQuery	= $(element);
			let		value		: any		= this.getOriginalValue(jElement);
			// Se è presente un valore lo setto nel controllo
			if ((value === null) || (value === undefined)) {
				return false;
			}

			let readValue: any;
			// leggo il valore impostato all'elemento
			if (jElement[0].tagName === Seac.Commons.Constants.inputElement.toUpperCase() || jElement[0].tagName ===  Seac.Commons.Constants.selectElement.toUpperCase()) {
				if (jElement.attr('type') === 'checkbox') {
					readValue = jElement.prop(Seac.Commons.Constants.checked);
				}else {
					readValue = jElement.val();
				}
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-selectbox')) {
				const selectBoxInstance: DevExpress.ui.dxDropDownBox = jElement.dxSelectBox(Seac.Commons.Constants.DevExpress.dxInstance);
				readValue = selectBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-dropdownbox')) {
				const dropdownBoxInstance: DevExpress.ui.dxDropDownBox = jElement.dxDropDownBox(Seac.Commons.Constants.DevExpress.dxInstance);
				readValue = dropdownBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-datebox')) {
				const dateBoxInstance: DevExpress.ui.dxDateBox = jElement.dxDateBox(Seac.Commons.Constants.DevExpress.dxInstance);
				readValue = dateBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
				// Converto il valore in data
				value = new Date(value);
			}else if (jElement.hasClass('dx-widget') && jElement.hasClass('dx-switch')) {
				const switchInstance: DevExpress.ui.dxSwitch = jElement.dxSwitch(Seac.Commons.Constants.DevExpress.dxInstance);
				readValue = switchInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
			}else if (jElement.hasClass('dx-widget') && $(element).hasClass('dx-numberbox')) {
				const numberBoxInstance: DevExpress.ui.dxNumberBox = jElement.dxNumberBox(Seac.Commons.Constants.DevExpress.dxInstance);
				readValue = numberBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
			}else if (jElement.hasClass('dx-widget') && $(element).hasClass('dx-textbox')) {
				const textBoxInstance: DevExpress.ui.dxTextBox = jElement.dxTextBox(Seac.Commons.Constants.DevExpress.dxInstance);
				readValue = textBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue);
			}
			// Se è presente un valore lo setto nel controllo
			if ((readValue === null) || (readValue === undefined)) {
				return false;
			}

			// Confronto i valori
			return JSON.stringify(value) == JSON.stringify(readValue);
		}

		/** Valore originale dell' elemento @param element, se il valore è stato precedentemente impostato torna null */
		private getOriginalValue(element: JQuery): any | null {
			return element.data(this._originalValueDataAttributeName)
		}

		/**
		 * Recupera l'indice di un elemento all'interno dei filtri salvati nel localStorage
		 * @param gridFilters Oggetto contenente tutti i filtri salvati
		 * @param gridId ID univoco della griglia a cui appartengono i filtri* @param gridId
		 * @param elementId Id dell'elemento da ricercare
		 */
		private findFilterIndex(gridFilters: GridFilters, gridId: string, elementId: string): number {
			let currentControlIndex: number = -1;
			for (let i = 0; i < gridFilters[gridId].length; i++) {
				if (Object.keys(gridFilters[gridId][i])[0] === elementId) {
					currentControlIndex = i;
				}
			}
			return currentControlIndex;
		}

		/**
		 * Stabilisce se una griglia ha filtri salvati nei cookie
		 * @param gridId ID univoco della griglia a cui appartengono i filtri
		 * @param normalize Funzione facoltativa di normalizzazione del dato letto. Viene utilizzata per modificare il valore del filtro letto, per esempio per convertire le date da stringa a Data oppure per recuperare l'effettivo item da una selectbox.
		 */
		public haveFilterControlsValue(gridId: string, normalize: GridFiltersValueNormalize = null): boolean {
			const filterIdentifier = this.filterIdentifierData(gridId, /*ignoreImpresa*/false, /*isPerPagina*/true);

			if (filterIdentifier.filters[filterIdentifier.gridInternalId] == undefined) {
				return false;
			}
			return true;
		}

	}

	export interface GridFilters {
		[key: string]: GridFiltersValue[]
	}
	export interface GridFiltersValue {
		[filterId: string]: any
	}

	/** Funzione di callback per la normalizzazione del valore del filtro */
	export interface GridFiltersValueNormalize {
		(filterId: string, value: any): any;
	}

	export const gridFilterPersistenceService: GridFilterPersistenceService = new GridFilterPersistenceService();
}